export const CONTACT_EMAIL = "support@dirtypawsapothecary.com";

export const SAFETY_NOTE =
  "Consult your veterinarian before beginning any new preparation, especially if your dog is pregnant, nursing, unwell or on medication. Our preparations are not intended to diagnose, treat, cure or prevent any disease.";

export const POLICIES = {
  "shipping-returns": {
    title: "Shipping & Returns",
    lede: "How a jar leaves the workshop, how it reaches your door, and what happens if it shouldn't have.",
    sections: [
      {
        heading: "Where we ship",
        body: [
          "We currently ship within Canada only. We are not yet able to send preparations to the United States or abroad.",
        ],
      },
      {
        heading: "When it leaves",
        body: [
          "Orders are measured, sealed and packed within 2 to 4 business days. Once your parcel is on its way, it typically arrives within 3 to 8 business days depending on your province or territory. Remote and northern addresses may take a little longer.",
          "Shipping is a flat $15 anywhere in Canada, and free on orders of $125 or more before savings, so any two full jars ship free. The final amount is shown at checkout before you pay.",
        ],
      },
      {
        heading: "Standing Orders",
        body: [
          "Standing Orders are coming soon, not open yet. When they open, you'll be able to skip, pause or cancel from your account.",
        ],
      },
      {
        heading: "Returns",
        body: [
          "Unopened jars may be returned within 30 days of delivery for a full refund of the product price. For the safety of every dog we serve, we cannot accept returns of opened jars.",
          "To begin a return, write to us with your order reference. Return shipping is the customer's responsibility unless the item arrived damaged or was sent in error. Refunds are issued to the original payment method within 10 business days of the jar reaching us.",
        ],
      },
      {
        heading: "Damaged or incorrect orders",
        body: [
          "If a jar arrives cracked, leaking, or is not what you ordered, write to us within 14 days of delivery with a photograph and your order reference. We will send a replacement at no cost, and you will not need to send the original back.",
        ],
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    lede: "What we keep, why we keep it, and who else ever sees it. The short answer: very little, and very few.",
    sections: [
      {
        heading: "What we collect",
        body: [
          "When you place an order, our payment processor collects your name, email address, billing and shipping address, and payment details. We receive your name, email, address and what you ordered. We never see or store your full card number.",
          "If you inscribe a name on the Honour Roll, we keep the name and years you enter, and they are shown publicly on the site. Answers you give in Find Their Mushroom and the Measure Calculator stay in your browser and are not sent to us.",
        ],
      },
      {
        heading: "Why we use it",
        body: [
          "We use your information only to fulfil and ship your order, send your order letter, a one-time refill reminder about a week before your jar is likely to run low, and any shipping notices, manage Standing Orders, and answer you when you write to us. Every reminder carries a link to stop them. We do not send marketing email unless you have expressly asked us to, and we do not sell or rent your information to anyone.",
        ],
      },
      {
        heading: "Who we share it with",
        body: [
          "We share only what is needed with the services that help us run the shop: Stripe, to process payments; our email provider, to send order letters; and our shipping carrier, to deliver your parcel. Some of these services may store information outside Canada, where it is subject to the laws of that country.",
        ],
      },
      {
        heading: "How long we keep it",
        body: [
          "We keep order records for as long as needed for tax and accounting obligations, typically seven years, and then delete them.",
        ],
      },
      {
        heading: "Your rights",
        body: [
          "Under Canadian privacy law (PIPEDA), you may ask to see the personal information we hold about you, ask us to correct it, or withdraw consent and ask us to delete it, subject to legal record-keeping requirements. Write to us and we will respond within 30 days.",
        ],
      },
    ],
  },
  terms: {
    title: "Terms of Sale",
    lede: "The plain agreement between the house and the people who shop here.",
    sections: [
      {
        heading: "About our preparations",
        body: [
          "Our mushroom preparations are wellness supplements for dogs. They are not medicines and are not intended to diagnose, treat, cure or prevent any disease. Consult your veterinarian before beginning any new preparation, especially if your dog is pregnant, nursing, unwell or on medication.",
          "The Find Their Mushroom consultation and the Measure Calculator offer general guidance only and are not a substitute for veterinary advice.",
        ],
      },
      {
        heading: "Orders and pricing",
        body: [
          "All prices are listed in Canadian dollars. Applicable taxes and any shipping costs are shown at checkout. We reserve the right to cancel an order if an item is unavailable or a price was listed in error; if that happens, you will be refunded in full.",
        ],
      },
      {
        heading: "Standing Orders",
        body: [
          "Standing Orders are coming soon, not open yet. When they open, a Standing Order will be a monthly subscription charged automatically to your payment method, and you'll be able to skip, pause or cancel from your account.",
        ],
      },
      {
        heading: "Shipping and returns",
        body: ["Shipping, returns and damaged orders are covered in our Shipping & Returns policy."],
      },
      {
        heading: "Liability",
        body: [
          "To the extent permitted by law, our liability for any order is limited to the amount you paid for it. Nothing in these terms limits any rights you have under Canadian consumer protection law.",
        ],
      },
      {
        heading: "Governing law",
        body: ["These terms are governed by the laws of the Province of Alberta and the federal laws of Canada that apply there."],
      },
    ],
  },
};

export const POLICY_LINKS = [
  ["Shipping & Returns", "/policies/shipping-returns"],
  ["Privacy Policy", "/policies/privacy"],
  ["Terms of Sale", "/policies/terms"],
];
